import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "login-dialog" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 2,
  class: "local"
}
const _hoisted_5 = { class: "mb-20" }
const _hoisted_6 = { class: "mb-20" }
const _hoisted_7 = {
  key: 3,
  class: "mt-20 text-center"
}
const _hoisted_8 = {
  key: 4,
  class: "mt-20 text-center"
}

import axios from 'axios';
import { useStore } from 'vuex';
import { ref, onMounted } from 'vue';

import epinioAuth, { EpinioAuthTypes } from '../utils/auth';
import { stringify, exceptionToErrorsArray } from '@shell/utils/error';
import { EpinioCluster } from '../models/cluster';

import { Banner } from '@components/Banner';
import Password from '@shell/components/form/Password';
import { LabeledInput } from '@components/Form/LabeledInput';


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginDialog',
  props: {
    cluster: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const store = useStore();

const emit = __emit;

const props = __props

const PROVIDER_TYPES = {
  LOCAL: 'local',
  DEX:   'dex',
};

const username = ref<string>('');
const password = ref<string>('');
const selectedAuthType = ref<string>('');
const busy = ref<boolean>(false);

let errors: Error[] = [];
let selectedTab: string;

onMounted(() => {
  if (!props.cluster.oidcEnabled) {
    selectedAuthType.value = PROVIDER_TYPES.LOCAL;
  } else {
    selectedAuthType.value = PROVIDER_TYPES.DEX;
  }
})

const selectType = (type: string) => {
  errors = [];
  selectedAuthType.value = type as string;
}

const login = async (provider: string) => {
  busy.value = true;
  errors = [];

  try {
    switch (provider) {
      case PROVIDER_TYPES.LOCAL:
        if (!username.value) {
          errors.push(new Error('Username'));
        }
        if (!password.value) {
          errors.push(new Error('Password'));
        }
        if (errors.length) {
          throw new Error(`${ errors.join('/') } Required`);
        }

        await epinioAuth.login(props.cluster.createAuthConfig(
          EpinioAuthTypes.LOCAL, {
            username: username.value,
            password: password.value,
            $axios:   axios,
          }
        ));
        break;
      case PROVIDER_TYPES.DEX:
        await epinioAuth.login(props.cluster.createAuthConfig(EpinioAuthTypes.DEX));
        break;
      default:
        throw new Error(`Unknown log in type: ${ selectedTab }`);
    }
    props.cluster.loggedIn = true;

    //Ensure the store knows the dialog has been closed. 
    emit('close');

    store.$router.push({
      name:   'epinio-c-cluster-dashboard',
      params: { cluster: props.cluster.id }
    });
  } catch (err) {
    errors.push(...exceptionToErrorsArray(err));
  }

  busy.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(errors).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(errors), (err, idx) => {
            return (_openBlock(), _createElementBlock("div", { key: idx }, [
              _createVNode(_unref(Banner), {
                color: "error",
                label: _unref(stringify)(err.Message || err)
              }, null, 8, ["label"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _cache[8] || (_cache[8] = _createTextVNode()),
    (selectedAuthType.value == PROVIDER_TYPES.DEX)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("button", {
            ref: "btn",
            class: _normalizeClass([{'disabled': busy.value}, "btn bg-primary"]),
            style: {"font-size":"18px"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (!busy.value && login(PROVIDER_TYPES.DEX)))
          }, _toDisplayString(_ctx.t('epinio.login.genericProvider')), 3)
        ]))
      : _createCommentVNode("", true),
    _cache[9] || (_cache[9] = _createTextVNode()),
    (selectedAuthType.value === PROVIDER_TYPES.LOCAL)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("form", null, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(LabeledInput), {
                id: "username",
                value: username.value,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((username).value = $event)),
                label: _ctx.t('login.username'),
                required: true
              }, null, 8, ["value", "label"])
            ]),
            _cache[6] || (_cache[6] = _createTextVNode()),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(Password), {
                id: "password",
                value: password.value,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
                label: _ctx.t('login.password'),
                required: true
              }, null, 8, ["value", "label"])
            ])
          ]),
          _cache[7] || (_cache[7] = _createTextVNode()),
          _createElementVNode("button", {
            ref: "btn",
            class: _normalizeClass(["btn bg-primary", {'disabled': busy.value}]),
            style: {"font-size":"18px"},
            onClick: _cache[3] || (_cache[3] = ($event: any) => (!busy.value && login(PROVIDER_TYPES.LOCAL)))
          }, _toDisplayString(_ctx.t(_ctx.cluster.oidcEnabled ? 'login.loginWithLocal' : 'epinio.login.login')), 3)
        ]))
      : _createCommentVNode("", true),
    _cache[10] || (_cache[10] = _createTextVNode()),
    (selectedAuthType.value === PROVIDER_TYPES.DEX)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("a", {
            class: _normalizeClass({'disabled': busy.value}),
            role: "button",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (!busy.value && selectType(PROVIDER_TYPES.LOCAL)))
          }, _toDisplayString(_ctx.t('login.useLocal')), 3)
        ]))
      : _createCommentVNode("", true),
    _cache[11] || (_cache[11] = _createTextVNode()),
    (_ctx.cluster.oidcEnabled && selectedAuthType.value === PROVIDER_TYPES.LOCAL)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("a", {
            class: _normalizeClass({'disabled': busy.value}),
            role: "button",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (!busy.value && selectType(PROVIDER_TYPES.DEX)))
          }, _toDisplayString(_ctx.t('epinio.login.useGenericProvider', {})), 3)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})